import * as actions from '../actions/actionTypes';

// All UI states of Form Templates will be definied here.
export const initialState = {
  readOnly: false,
  // TODO: activeAccordion: []
  // TODO: validateAllFields: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_READ_ONLY:
      return { ...state, readOnly: action.isView };

    default:
      return state;
  }
}
